import styled from 'styled-components'

import { ImageOrientation } from './enum'

type CustomImageProps = {
  src?: string
  alt?: string
  fillImage?: boolean
  orientation?: ImageOrientation
  className?: string
  dataTest?: string
}

interface StyledImageProps {
  fetchpriority?: 'high' | 'low' | 'auto'
  fillImage: boolean
  orientation: ImageOrientation
}

const orientationImage = (orientation: ImageOrientation) => {
  switch (orientation) {
    case ImageOrientation.HORIZONTAL:
      return `16 / 9`
    case ImageOrientation.VERTICAL:
      return `9 / 13`
    default:
      return `auto`
  }
}

const Image = styled.img<StyledImageProps>`
  max-width: 100%;
  border: 0;
  aspect-ratio: ${({ orientation }) => orientationImage(orientation)};

  ${({ fillImage }) =>
    `
      width: ${fillImage ? '100%' : 'auto'};
      object-fit: ${fillImage ? 'cover' : 'contain'};
      object-position: center center;
    `}
`

const CustomImage = ({
  src,
  fillImage = false,
  orientation = ImageOrientation.HORIZONTAL,
  alt,
  className,
  dataTest = 'custom-img'
}: CustomImageProps) => {
  return (
    <Image
      src={src}
      alt={alt}
      loading='lazy'
      fetchpriority='low'
      decoding='async'
      fillImage={fillImage}
      orientation={orientation}
      className={className}
      data-test={dataTest}
    />
  )
}

export default CustomImage
